"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var defaultButton = function (props) { return react_1.default.createElement("button", __assign({}, props), props.children); };
var SellerGroupModelListPagination = /** @class */ (function (_super) {
    __extends(SellerGroupModelListPagination, _super);
    function SellerGroupModelListPagination(props) {
        var _this = _super.call(this, props) || this;
        _this.getVisiblePages = function (page, pages) {
            console.log('getVisiblePages pages', pages);
            var start = 1;
            var vPages = [];
            for (var v = 0; v < pages; v++) {
                vPages.push(start + v);
            }
            return vPages;
            // @ts-ignore
            //return [...Array(pages).keys()].map(v => start + v);
        };
        _this.changePage = function (page) {
            // ReactTable props onPageChange is 0-indexed subtract 1
            if (_this.props.onPageChange) {
                _this.props.onPageChange(page - 1);
            }
        };
        console.log('SellerGroupModelListPagination props', props);
        console.log('SellerGroupModelListPagination props.pages', props.pages);
        _this.changePage = _this.changePage.bind(_this);
        _this.getVisiblePages = _this.getVisiblePages.bind(_this);
        _this.state = {
            visiblePages: _this.getVisiblePages(null, props.pages),
        };
        return _this;
    }
    SellerGroupModelListPagination.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.pages !== nextProps.pages) {
            this.setState({
                visiblePages: this.getVisiblePages(null, nextProps.pages),
            });
        }
    };
    SellerGroupModelListPagination.prototype.render = function () {
        var _this = this;
        var _a = this.props.PageButtonComponent, PageButtonComponent = _a === void 0 ? defaultButton : _a;
        var visiblePages = this.state.visiblePages;
        var currentPage = this.props.page + 1; // props.page is 0-indexed use actual number for current page
        function createPrevIcon() {
            // only display prev icon if there are multiple pages
            if (visiblePages !== undefined && visiblePages.length > 0 && currentPage > 1) {
                return { __html: '<i class="fa fa-chevron-left"></i>' };
            }
        }
        function createNextIcon() {
            // only display next icon if there are multiple pages AND not the last page
            if (visiblePages !== undefined &&
                visiblePages.length > 1 &&
                visiblePages.length != currentPage) {
                return { __html: '<i class="fa fa-chevron-right"></i>' };
            }
        }
        function isPageWithinRange(arrayIndex) {
            var currentPageIndex = currentPage - 1;
            var prev3Pages = currentPageIndex - 3;
            var next3Pages = currentPageIndex + 3;
            // if it's few pages then pad the next few pages with what's missing from current page
            if (prev3Pages < 0) {
                next3Pages = next3Pages + prev3Pages * -1;
            }
            // if it's last pages then pad the previous with (last page minus next 3 pages)
            var lastPage = visiblePages.length - 1;
            if (lastPage < next3Pages) {
                prev3Pages = prev3Pages - (next3Pages - lastPage);
            }
            return arrayIndex <= next3Pages && arrayIndex >= prev3Pages;
        }
        if (visiblePages.length <= 1) {
            // no visible pages, do not render page section
            return null;
        }
        return (react_1.default.createElement("div", { className: "ReactTable__pagination" },
            react_1.default.createElement("div", { className: "ReactTable__prevPageWrapper" },
                react_1.default.createElement(PageButtonComponent, { className: "ReactTable__pageButton", onClick: function () {
                        if (currentPage === 1)
                            return;
                        _this.changePage(currentPage - 1);
                    }, disabled: currentPage === 1 },
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: createPrevIcon() }))),
            react_1.default.createElement("div", { className: "ReactTable__visiblePagesWrapper" }, visiblePages.length > 1 &&
                visiblePages.map(function (page, index) {
                    return (isPageWithinRange(index) && (react_1.default.createElement(PageButtonComponent, { key: page, className: currentPage === page
                            ? 'ReactTable__pageButton ReactTable__pageButton--active'
                            : 'ReactTable__pageButton', onClick: _this.changePage.bind(_this, page) }, page)));
                })),
            react_1.default.createElement("div", { className: "ReactTable__nextPageWrapper" },
                react_1.default.createElement(PageButtonComponent, { className: "ReactTable__pageButton", onClick: function () {
                        if (currentPage === _this.props.pages)
                            return;
                        _this.changePage(currentPage + 1);
                    }, disabled: currentPage === this.props.pages },
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: createNextIcon() })))));
    };
    SellerGroupModelListPagination.propTypes = {
        pages: prop_types_1.default.number,
        page: prop_types_1.default.number,
        PageButtonComponent: prop_types_1.default.any,
        onPageChange: prop_types_1.default.func,
        previousText: prop_types_1.default.string,
        nextText: prop_types_1.default.string,
    };
    return SellerGroupModelListPagination;
}(react_1.default.Component));
exports.default = SellerGroupModelListPagination;
